import type {
  JwtExecuteRequestType,
  JwtExecuteResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useJwtExecute = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: JwtExecuteRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `jwt/execute`,
        data,
      }).then(
        (data) => apiV2AssertResponse(data).data as JwtExecuteResponseType,
      ),
  });
};
